import { Grid, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import type { AxiosError } from 'axios';
import axios from 'axios';
import * as React from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import useEventListener from '../../lib/useEventListener';

const Courier: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const routeCourier = (barcodeParam: string) => {
    if (barcodeParam.trim().length === 0) {
      enqueueSnackbar('Barcode cannot be empty', { variant: 'error' });
    }
    axios.get<string>('/courier/RouteCourier', {
      params: {
        barcode: barcodeParam,
      },
    })
      .then((response) => {
        if (response.data === 'Bin') {
          navigate(`/courier-dropoff/${barcodeParam}`);
        } else if (response.data === 'Repair') {
          navigate(`/courier-pickup/${barcodeParam}`);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 404) {
          enqueueSnackbar(error?.response?.data, { persist: false, variant: 'error' });
        } else {
          console.log({ error });
        }
      });
  };

  let barcodeBuffer = '';

  const handleBarcodeInput = (e: KeyboardEvent) => {
    if (!(e.target instanceof HTMLInputElement) && (e.key.length === 1 || e.key === 'Enter')) {
      if (e.key !== 'Enter') {
        barcodeBuffer = `${barcodeBuffer}${e.key}`;
      } else {
        if (!e.defaultPrevented && barcodeBuffer.trim().length !== 0) {
          routeCourier(barcodeBuffer);
        }
        barcodeBuffer = '';
      }
    }
  };

  useEventListener('keydown', handleBarcodeInput);

  return (
    <Grid container direction="column" spacing={2} alignItems="center" justifyContent="center">
      <Grid item>
        <Alert severity="info">{'Scan in repair or bin to start the pick up or drop off process.'}</Alert>
      </Grid>
      <Grid item>
        <TextField
          id="courier-input"
          variant="outlined"
          size="small"
          onKeyPress={
              (event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  event.stopPropagation();
                  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                  routeCourier((event.target as HTMLInputElement).value);
                }
              }
            }
        />
      </Grid>
    </Grid>
  );
};

export default Courier;
